import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ChartOptions, ChartType, ChartDataset } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';
import { Task } from 'src/app/models/Task';
import { Modules } from 'src/app/models/Modules';
import * as _ from 'underscore';
import { AnalyticsTask } from 'src/app/models/AnalyticsTask';
@Component({
  selector: 'app-bar-chart-processes',
  templateUrl: './bar-chart-processes.component.html',
  styleUrls: ['./bar-chart-processes.component.css']
})
export class BarChartProcessesComponent implements OnInit {
  public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      x: {
      }, y: {
        ticks: {
          autoSkip: false,

        }
      }
    },
    plugins: {
      datalabels: {
        display: false,
      }
    },
    indexAxis: 'y', // This line makes the bar chart horizontal


  };
  public barChartLabels: string[] = [];
  public barChartType: ChartType = 'bar';
  public barChartMinLabels: string[] = [];
  public barChartLegend = true;
  public barChartPlugins = [pluginDataLabels];


  @ViewChild(BaseChartDirective, { static: false }) chart: BaseChartDirective;
  public barChartColors: any[] = [

    { // red
      backgroundColor: 'lightgreen',
      borderColor: 'lightgreen',
      pointBackgroundColor: 'lightgreen',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
    }
  ];
  public barChartData: ChartDataset[] = [];

  public barChartMinData: ChartDataset[] = [];
  @Input() dataset: Array<AnalyticsTask>;
  @Input() processes: Array<Modules>;
  public dynHeight = 300;
  public dynWidth = 40;
  public mobile;
  public outLabel;
  public outValue;
  public sortedArray = [];
  public sortedMinArray = [];
  public outMinLabel;
  public outMinValue;
  constructor() { }

  ngOnInit() {
    if (window.screen.width < 500) { // 768px portrait
      this.mobile = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.processes.length < 20 && this.processes.length > 20) {
      this.dynHeight = 500;
    } else if (this.processes.length < 50 && this.processes.length > 20) {
      this.dynHeight = 1000;
    } else if (this.processes.length > 100 && this.processes.length > 50) {
      this.dynHeight = 2000;
      this.dynWidth = 75;
    } else if (this.processes.length < 20) {
      this.dynHeight = 300;
      this.dynWidth = 75;
    }
    this.barChartOptions = { ...this.barChartOptions };
    if (changes) {
      this.drawBarChart();
    }
  }
  removeDuplicates(arr: any[]): any[] {
    return Array.from(new Set(arr));
  }
  drawBarChart() {
    let tempProcess = [];
    let counter = 0;
    let dataArrayOfDuration = [];
    let sumDuration = 0;

    for (let item of this.processes) {
      if (this.dataset) {
        for (let i = 0; i < this.dataset.length; i++) {
          if (item.nameSmall == this.dataset[i].process) {
            counter++;
            sumDuration += this.dataset[i].timespend;
          }
        }
        dataArrayOfDuration.push(sumDuration);
        sumDuration = 0; // Reset sumDuration for the next iteration
      }
      tempProcess.push(counter);
      counter = 0; // Reset counter for the next iteration
    }

    let labels = [];
    for (let item of this.processes) {
      // Trim the label to 20 characters
      let trimmedLabel = item.nameSmall.length > 20 ? item.nameSmall.substring(0, 20) + '...' : item.nameSmall;
      labels.push(trimmedLabel);
    }

    let arraySort = [];
    for (let i = 0; i < labels.length; i++) {
      arraySort.push({ label: labels[i], value: tempProcess[i] });
    }
    this.sortedArray = _.sortBy(arraySort, 'value');
    this.sortedArray.reverse();
    this.outLabel = [];
    this.outValue = [];
    for (let item of this.sortedArray) {
      if (item.value > 0) {
        this.outLabel.push(item.label);
        this.outValue.push(item.value);
      }
    }
    this.outLabel = this.removeDuplicates(this.outLabel);

    this.barChartLabels = this.outLabel;
    this.barChartData = [{
      data: this.outValue,
      label: 'Št. opravil',
      backgroundColor: 'lightgreen'
    }];

    let arrayMinSort = [];
    for (let i = 0; i < labels.length; i++) {
      arrayMinSort.push({ label: labels[i], value: dataArrayOfDuration[i] });
    }
    this.sortedMinArray = _.sortBy(arrayMinSort, 'value');
    this.sortedMinArray.reverse();
    this.outMinLabel = [];
    this.outMinValue = [];
    for (let item of this.sortedMinArray) {
      if (item.value > 0) {
        this.outMinLabel.push(item.label);
        this.outMinValue.push(item.value);
      }
    }
    if (this.outMinValue.length < 20 && this.outMinValue.length > 20) {
      this.dynHeight = 500;
    } else if (this.outMinValue.length < 50 && this.outMinValue.length > 20) {
      this.dynHeight = 1000;
    } else if (this.outMinValue.length > 100 && this.outMinValue.length > 50) {
      this.dynHeight = 2000;
      this.dynWidth = 75;
    } else if (this.outMinValue.length < 20) {
      this.dynHeight = 300;
      this.dynWidth = 75;
    }
    this.barChartMinLabels = this.outMinLabel;
    this.barChartMinLabels = this.removeDuplicates(this.barChartMinLabels);
    this.barChartMinData = [{
      data: this.outMinValue, label: 'Št. porabljenih minut', backgroundColor: 'lightgreen'
    }];
  }

}
